













import Vue from 'vue'
export default Vue.extend ({
    props: {
        //  Determines the color of the circular spinner
        color: {
            type: String,
            default: 'primary'
        },
        //  Determines if the circular is displayed in a persistent dialog
        dialog: {
            type: Boolean,
            default: false
        },
        //  The size of our loading mask, defaults to 64
        size: {
            type: [String, Number],
            default: 64
        }
    }
})
